import { DelineationPicker } from './DelineationPicker';
import { DelineationImporter } from './DelineationImporter';
import { HStack, Text } from '@cdl/heartbeat-react';
import { SavedStatus } from './SavedStatus';
import { useSelector } from 'react-redux';
import {
  delineationChangedSelector,
  selectedDelineationIdSelector,
  userDelineationSelector,
} from '../selectors/delineation.selectors';
import { SidebarSection } from '../../../shared/components/SidebarSection';

export const DelineationPickerSection: React.FC = () => {
  const selectedId = useSelector(selectedDelineationIdSelector);
  const userDelineation = useSelector(userDelineationSelector);
  const delineationChanged = useSelector(delineationChangedSelector);
  return (
    <SidebarSection data-testid='beat-annotation'>
      <HStack justifyContent='space-between'>
        <Text textStyle='section-subtitle'>Beat Annotation</Text>
        {selectedId === userDelineation?.id && (
          <SavedStatus changed={delineationChanged} />
        )}
        <DelineationImporter />
      </HStack>
      <DelineationPicker />
    </SidebarSection>
  );
};
